import GenericDictionaryPage from "./GenericDictionaryPage";
import { getImprovementPlanFinalizeReason } from "../api/improvementPlanFinalizeReason";

export default function ImprovementPlanFinalizeReason() {
    return (
        <GenericDictionaryPage
            tableKey="improvementPlanFinalizeReasons"
            fetchData={getImprovementPlanFinalizeReason}
            titleKey="genericDic:improvementPlanFinalizeReasons"
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:improvementPlanFinalizeReason").toLowerCase()
                })
            }
        />
    );
}
